import { Button } from 'antd'
import { HTMLAttributes, ReactNode, useEffect } from 'react'

import { getContentFromCustomCompletePage } from '@/pages/FormBuilderSettingsCompletePage/UtilsCompletePage/getContentFromCustomCompletePage'
import { getCustomCompletePageIcons } from '@/pages/FormBuilderSettingsCompletePage/UtilsCompletePage/getCustomCompletePageIcons'
import { getIconFromCustomCompletePage } from '@/pages/FormBuilderSettingsCompletePage/UtilsCompletePage/getIconFromCustomCompletePage'
import { getThemeFromCustomCompletePage } from '@/pages/FormBuilderSettingsCompletePage/UtilsCompletePage/getThemeFromCustomCompletePage'
import { getUploadImageFromCustomCompletePage } from '@/pages/FormBuilderSettingsCompletePage/UtilsCompletePage/getUploadImageFromCustomCompletePage'
import { sanitizeHtml } from '@/utils/sanitizeHtml/sanitizeHtml'
import cn from '@/utils/tailwind/cn'

import { ModalSuccess } from './ModalSuccess'

type Props = {
  isVisible: boolean
  onClose?: () => void | Promise<void>
  canDismiss?: boolean
  title?: string
  description?: ReactNode
  hideButton?: boolean
  buttonTitle?: string
  hasCallback?: boolean
  callbackDelay?: number
  callback?: () => void
  fixed?: boolean
  extraContent?: ReactNode
  data?: string
} & HTMLAttributes<HTMLDivElement>
export const ModalSuccessCustom = ({
  isVisible,
  onClose,
  hideButton,
  buttonTitle,
  hasCallback,
  callbackDelay,
  callback,
  fixed,
  extraContent,
  data,
  className,
}: Props) => {
  const currentUpload = getUploadImageFromCustomCompletePage(data)
  const currentIcon = getIconFromCustomCompletePage(data)

  const currentTheme = getThemeFromCustomCompletePage(data) || '#51a855'

  const html = sanitizeHtml(getContentFromCustomCompletePage(data))

  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout> | null = null
    if (isVisible && hasCallback && callback) {
      timeout = setTimeout(() => {
        callback()
      }, callbackDelay ?? 5000)
    }
    return () => {
      if (timeout !== null) {
        clearTimeout(timeout)
        timeout = null
      }
    }
  }, [callback, callbackDelay, hasCallback, isVisible])
  if (!isVisible) return null
  return (
    <ModalSuccess.Root className={cn({ 'fixed z-50': fixed }, className)}>
      <ModalSuccess.Wrapper>
        <ModalSuccess.Bar
          style={{
            backgroundImage: `linear-gradient(118deg, ${currentTheme}, ${currentTheme}75)`,
          }}
        />
        <ModalSuccess.Content>
          {!extraContent ? (
            <>
              {currentIcon ? (
                <ModalSuccess.Icon style={{ background: currentTheme + '1a' }}>
                  {
                    getCustomCompletePageIcons({
                      style: { color: currentTheme },
                    })[currentIcon]
                  }
                </ModalSuccess.Icon>
              ) : null}
              {currentUpload && (
                <div className="relative h-32 w-32 cursor-pointer overflow-hidden rounded border-2 border-transparent hover:border-primary">
                  <img
                    alt="Preview"
                    className="h-full w-full object-cover"
                    src={currentUpload}
                  />
                </div>
              )}
              <div
                className="tiptap"
                dangerouslySetInnerHTML={{ __html: html }}
              />
              <div className="flex justify-center">
                {!hideButton && (
                  <Button
                    className="mt-3"
                    data-cy="dismiss-button"
                    onClick={onClose}
                    type="link"
                  >
                    {buttonTitle || 'Dismiss'}
                  </Button>
                )}
              </div>
            </>
          ) : (
            extraContent
          )}
        </ModalSuccess.Content>
      </ModalSuccess.Wrapper>
    </ModalSuccess.Root>
  )
}
